import {connectRoutes, LocationState} from "redux-first-router";
import { createStore, combineReducers, applyMiddleware} from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk'
import {logger} from 'redux-logger'
import { routePaths } from './routes'
import {history} from "App/routes/history";
import queryString from 'query-string';
import {
    reducer as apiReducer,
    State as ApiState,
    initialState as apiInitialState
} from "App/services";
import {
    Currency,
    currencyInitialState,
    currencyReducer,
    detailPriceInitialState,
    detailPriceReducer
} from "App/constants";
import {
    initialState as basketInitialState,
    reducer as basketReducer,
    Basket
} from "App/basket";
import {configurationCookieInitialState, configurationCookieReducer} from "App/services/reducers/configurationCookie";
import {
    initialState as contactDataInitialState,
    reducer as contactDataReducer,
    ContactData
} from "App/contactData";
import {countrycodeInitialState, countrycodeReducer, guessCountryCode} from "App/country";

const {
    reducer: routeReducer,
    middleware: routeMiddleware,
    enhancer: routeEnhancer
} = connectRoutes(history, routePaths, {
    querySerializer: queryString
});

//devtools
const composeEnhancers = composeWithDevTools({
    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

/*
 * This is the root state of the app
 * It contains every substate of the app
 */
export interface ApplicationState {
    location?: LocationState
    data: ApiState
    basket: Basket
    contactData: ContactData
    currency: Currency
    detailPrice: boolean
    configurationCookie: any|null
    countrycode: string
}

/*
 * initialState of the app
 */
export function initialState(): ApplicationState {
    return {
        data: apiInitialState,
        currency: currencyInitialState,
        basket: basketInitialState,
        contactData: contactDataInitialState,
        detailPrice: detailPriceInitialState,
        configurationCookie: configurationCookieInitialState,
        countrycode: countrycodeInitialState
    };
}

export function configureStore () {
    const store = createStore(
        combineReducers<ApplicationState>({
            location: routeReducer,
            data: apiReducer,
            currency: currencyReducer,
            basket: basketReducer,
            contactData: contactDataReducer,
            detailPrice: detailPriceReducer,
            countrycode: countrycodeReducer,
            configurationCookie: configurationCookieReducer
        }),
        initialState(),
        composeEnhancers(routeEnhancer, applyMiddleware(routeMiddleware, thunkMiddleware, logger))
    );
    // Collect current country information
    store.dispatch(guessCountryCode());
    return store;
}



// WEBPACK FOOTER //
// ./src/store.ts